/**
 * Google Maps driving directions to a site (Jim 2026-10-06: "I want that
 * link button everywhere that site map is and on the popups on the map").
 */
export function directionsUrl(latitude: number, longitude: number): string {
  return `https://www.google.com/maps/dir/?api=1&destination=${latitude},${longitude}`;
}

export function hasCoordinates(
  latitude: number | null | undefined,
  longitude: number | null | undefined
): latitude is number {
  return (
    typeof latitude === 'number' &&
    typeof longitude === 'number' &&
    Number.isFinite(latitude) &&
    Number.isFinite(longitude) &&
    !(latitude === 0 && longitude === 0)
  );
}

/** The same button as plain HTML, for maps that build their popups as strings. */
export function directionsPopupHtml(
  latitude: number,
  longitude: number
): string {
  if (!hasCoordinates(latitude, longitude)) return '';
  return (
    `<a href="${directionsUrl(latitude, longitude)}" target="_blank" rel="noopener noreferrer" ` +
    'style="display:inline-flex;align-items:center;gap:4px;margin-top:6px;padding:4px 8px;background:#ecfdf5;color:#047857;border-radius:6px;font-size:12px;font-weight:600;text-decoration:none;">' +
    'Directions &rarr;</a>'
  );
}
